import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from 'react';
import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";
import icons from "../../../database/icone";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import axios from "axios";
import { useStateContext } from "../../../Context/ContextProvider";
import { useSearch } from "../../../Context/SearchContext";

export default function Catalogue() {
    const [onlineModules, setOnlineModules] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem('ACCESS_TOKEN');
    const navigate = useNavigate();
    //zone de recherche
    const { searchTerm } = useSearch();

    const setting = JSON.parse(sessionStorage.getItem("setting"));

    const { ModuleComptes } = useStateContext();

    //bg couleur selon le niveau
    const levelColors = {
        'Intermédiaire': '#ECFCCB',
        'MasterClass': '#FFE4E6',
        'Fondamentaux': '#CCFBF1',
        'Avancée': '#DBEAFE',
    };

    // couleur text selon le niveau
    const textColors = {
        'Intermédiaire': '#3F6253',
        'MasterClass': '#9F1276',
        'Fondamentaux': '#2388B6',
        'Avancée': '#4F40BC'
    }

    const baseURL = `${process.env.REACT_APP_URL_IMAGE}/`;

    //evaluation note
    const fetchNote = async (idModule) => {
        try {
            const response = await axios.get(`https://catalogue.mg.formafusion.io/api/get-note/${idModule}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: "application/json",
                    },
                }
            );

            // Vérification de la structure des données
            return {
                note: response.data?.note || 0,
                avis: response.data?.nombre_evaluations || 0
            };

        } catch (error) {
            console.error(`Erreur note module ${idModule}`, error);
            return { note: 0, avis: 0 };
        }
    };

    const renderStars = (note) => {
        const stars = [];
        const fullStars = Math.floor(note); // nombre d'étoiles pleines
        const hasHalfStar = note - fullStars >= 0.25 && note - fullStars <= 0.75; // condition pour étoile demi
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

        // Étoiles pleines
        for (let i = 0; i < fullStars; i++) {
            stars.push(<FaStar key={`full-${i}`} className="text-yellow-400" />);
        }

        // Étoile demi
        if (hasHalfStar) {
            stars.push(<FaStarHalfAlt key="half" className="text-yellow-400" />);
        }

        // Étoiles vides
        for (let i = 0; i < emptyStars; i++) {
            stars.push(<FaRegStar key={`empty-${i}`} className="text-yellow-400" />);
        }

        return stars;
    };


    // const fetchModules = async () => {
    //     setIsLoading(true);
    //     try {
    //         const token = localStorage.getItem('ACCESS_TOKEN');
    //         const response = await axios.get('https://catalogue.mg.formafusion.io/api/cfp/modules', {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 Accept: 'application/json'
    //             }
    //         });
    //         const onlineData = response.data.onlineModules || [];
    //         setOnlineModules(onlineData);

    //     } catch (error) {
    //         console.error("Erreur lors de la récupération:", error);
    //     } finally {
    //         setIsLoading(false);
    //     }
    // };
    const fetchModules = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get('https://catalogue.mg.formafusion.io/api/cfp/modules', {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });

            const onlineData = response.data.onlineModules || [];

            // Boucle sur tous les modules et ajoute les notes
            const updatedModules = await Promise.all(
                onlineData.map(async (domaine) => {
                    const modulesWithNotes = await Promise.all(
                        domaine.modules.map(async (mod) => {
                            const noteData = await fetchNote(mod.idModule);
                            return {
                                ...mod,
                                note: noteData.note,
                                avis: noteData.avis // Correction du nom de propriété
                            };
                        })
                    );
                    return { ...domaine, modules: modulesWithNotes };
                })
            );

            setOnlineModules(updatedModules);
        } catch (error) {
            console.error("Erreur lors de la récupération:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchModules();
        fetchNote();
    }, []);

    //changement de status
    const updateStatus = async (id, action) => {
        console.log("id:", id);
        console.log("action:", action);
        try {
            const token = localStorage.getItem('ACCESS_TOKEN');
            console.log("Token utilisé :", token);
            const response = await axios.patch(`https://catalogue.mg.formafusion.io/api/cfp/modules/${id}/${action}`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    Accept: 'application/json'
                }
            });
            if (response.status === 200) {
                setOnlineModules(prev =>
                    prev.map(domaine => ({
                        ...domaine,
                        modules: domaine.modules.filter(mod => mod.idModule !== id)
                    })).filter(domaine => domaine.modules.length > 0)
                );
                toast.success("Mise à jour avec succès");
                ModuleComptes();

                setTimeout(() => {
                    if (action === "offline") {
                        navigate("/cfp/catalogue/preparation")
                    } else if (action === "trash") {
                        navigate("/cfp/catalogue/corbeille")
                    }
                }, 2000);

            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.log("une erreur est survenue");
        }

    };

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            <div className="flex flex-col items-center justify-start w-full max-w-screen-xl min-h-screen mx-auto space-y-2 p-2 mt-10 sm:mt-14 lg:mt-16">
                {/* Modules disponibles */}
                <div>
                    {isLoading ? (
                        <div className="fixed inset-0 bg-black bg-opacity-20 backdrop-blur-sm z-50 flex items-center justify-center px-4">
                            <div className="text-center">
                                <p className="text-gray-700 text-lg sm:text-xl font-semibold">veuillez patienter...</p>
                                <div className="flex justify-center space-x-2 mt-2">
                                    <div className="w-3 h-3 animate-bounce">📚</div>
                                    <div className="w-3 h-3 animate-bounce [animation-delay:-0.2s]">📚</div>
                                    <div className="w-3 h-3 animate-bounce [animation-delay:-0.4s]">📚</div>
                                </div>
                            </div>
                        </div>
                    ) : onlineModules && onlineModules.length > 0 ? (
                        onlineModules
                            .filter(domaineItem => {
                                const domaineName = domaineItem.domaine || '';
                                return domaineName.toLowerCase().includes(searchTerm.toLowerCase());
                            })
                            .map((domaineItem, index) => (
                                <div key={index} className="mb-8">
                                    {/* En-tête du domaine - Texte réduit sur mobile */}
                                    <div className="flex justify-between items-center w-full p-2 text-lg sm:text-xl font-semibold bg-slate-400 rounded-lg h-10 mt-5">
                                        <h1 className="text-xs sm:text-sm md:text-[15px] text-slate-950 truncate">
                                            {domaineItem.domaine || 'Domaine inconnu'}
                                        </h1>
                                        <h2 className="bg-white rounded-xl w-16 sm:w-20 h-6 sm:h-7 text-center text-xs sm:text-[13px] flex items-center justify-center">
                                            {domaineItem.modules?.length || 0} module{domaineItem.modules?.length !== 1 ? 's' : ''}
                                        </h2>
                                    </div>

                                    {/* Grille responsive - 1 colonne mobile, 2 tablettes, 3+ desktop */}
                                    <ul className="grid grid-cols-1 gap-4 sm:gap-6 md:gap-8 lg:gap-12 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 mt-4">
                                        {domaineItem.modules
                                            ?.filter((module) => {
                                                const name = module.module_name || module.name || '';
                                                return name.toLowerCase().includes(searchTerm.toLowerCase());
                                            })
                                            .map((module) => {
                                                const name = module.module_name || module.name || 'Nom inconnu';
                                                const image = module.module_image || 'default.jpg';
                                                const level = module.module_level_name || 'Niveau inconnu';
                                                const dureeJ = module.module_dureeJ ?? module.dureeJ ?? 0;
                                                const dureeH = module.module_dureeH ?? module.dureeH ?? 0;
                                                const prix = module.module_price ?? module.prix ?? 0;
                                                const formed = module.totalFormed || 0;
                                                const moduleId = module.idModule;

                                                return (
                                                    <li key={moduleId} className="w-full col-span-1 bg-white shadow-lg sm:shadow-xl rounded-lg sm:rounded-xl p-3 sm:p-4 border-gray-200 border-2 group">
                                                        <div className="flex gap-4 sm:gap-7">
                                                            <figure className="h-[70px] sm:h-[80px] w-40 bg-slate-100 rounded-md overflow-hidden mb-2">
                                                                <img
                                                                    src={`${baseURL}${image}`}
                                                                    alt="Illustration"
                                                                    className="w-full h-full object-cover"
                                                                />
                                                            </figure>
                                                            <p
                                                                className=" font-bold text-[10px] sm:text-[12px] mb-1 px-2 py-0 rounded-lg h-6 flex items-center"
                                                                style={{ backgroundColor: levelColors[level], color: textColors[level] }} // couleur par défaut
                                                            >
                                                                {level}
                                                            </p>
                                                        </div>

                                                        <h2 className="text-xs sm:text-[12px] font-semibold text-[#333] mb-1 truncate">{name}</h2>

                                                        <div className="flex items-center gap-1 mb-2 text-slate-400 text-xs sm:text-sm">
                                                            {renderStars(module.note || 0)}
                                                            <p>{(module.note || 0).toFixed(1)}</p> {/* 1 décimale suffit */}
                                                            <p>({module.avis || 0} avis)</p>
                                                        </div>



                                                        <div className="grid grid-cols-2 gap-2 mb-1">
                                                            <p className="text-slate-500 inline-flex items-center gap-1 text-xs sm:text-sm">
                                                                <icons.clock className="text-xs sm:text-sm" /> {dureeJ} jours ({dureeH}h)
                                                            </p>
                                                            <p className="text-slate-500 text-xs sm:text-sm text-right">Ar {parseInt(prix)}</p>
                                                        </div>

                                                        <div className="flex justify-between">
                                                            <p className="text-slate-500 inline-flex items-center gap-1 text-xs sm:text-sm">
                                                                <icons.users /> {formed} formé(s)
                                                            </p>
                                                        </div>

                                                        <div className="flex items-center justify-end border-t pt-2 gap-2 sm:gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                                            <Link
                                                                to={`/${moduleId}/edit`}
                                                                className="btn btn-ghost btn-sm" title="Voir les détails"
                                                                state={{ fromStatus: 'online' }}
                                                            >
                                                                <icons.eye className="text-xs sm:text-sm" />
                                                            </Link>
                                                            <button className="btn btn-ghost btn-sm" title="Mettre en préparation" onClick={() => updateStatus(module.idModule, 'offline')}>
                                                                <icons.settings className="text-xs sm:text-sm" />
                                                            </button>
                                                            <button className="btn btn-ghost btn-sm" title="Mettre en corbeille" onClick={() => updateStatus(module.idModule, 'trash')}>
                                                                <icons.trash className="text-xs sm:text-sm" />
                                                            </button>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            ))
                    ) : (
                        <h1 className="text-center mt-10 text-gray-500">Aucun module disponible dans le Centre de Formation</h1>
                    )}
                </div>

            </div>
        </>
    );
}